import { ObjectUtils } from "~app/common/utils/object-utils";
import { StringUtils } from "~app/common/utils/string-utils";
import { IAtgard } from "~app/features/planera/model/IAtgard";
import { IOperationBase } from "~app/features/planera/model/IOperationBase";
import { IArbetsorderValidationInfo } from "~app/features/shared/components/arbetsorder-viol3-button/IArbetsorderValidationInfo";
import { DestineringsRadViewModel } from "./DestineringsRadViewModel";
import { IExternArbetsorderDetails } from "./IExternArbetsorderDetails";
export class ExternArbetsorderDetailsViewModel implements IArbetsorderValidationInfo {
    destineringsrader: DestineringsRadViewModel[];
    constructor(private readonly model: IExternArbetsorderDetails) {
        this.destineringsrader = model.destineringsrader.map(x => new DestineringsRadViewModel(x));
    }

    get transportforetagId(): number {
        return ObjectUtils.isNullOrUndefined(this.model.transportforetagId) ? undefined : this.model.transportforetagId;
    }

    set transportforetagId(value: number) {
        this.model.transportforetagId = value;
    }

    get avtalsobjekt(): string {
        return this.model.avtalsobjekt;
    }

    get eudrValid(): boolean {
        // Rask ansvarar inte över EUDR här
        return true;
    }

    get arbetsorderNamn(): string {
        return this.model.arbetsorderNamn;
    }

    get id(): number {
        return this.model.arbetsorderId;
    }

    get uppdragsgivare(): string {
        if (!ObjectUtils.isNullOrUndefined(this.model.ckLeverantorKod)) {
            return `${this.model.ckLeverantorNamn} (${this.model.ckLeverantorKod})`;
        }

        if (!ObjectUtils.isNullOrUndefined(this.model.uppdragsgivareKod)) {
            return `${this.model.uppdragsgivare} (${this.model.uppdragsgivareKod})`;
        }
        return this.model.uppdragsgivare;
    }

    get kontraktsansvarig(): string {
        if (!this.model.kontraktsansvarig) {
            return null;
        }

        return `${this.model.kontraktsansvarig} (${this.model.kontraktsansvarigKod || ""})`;
    }

    get kontraktsansvarigKod(): string {
        return this.model.kontraktsansvarigKod;
    }

    get ckLeverantorKod(): string {
        return this.model.ckLeverantorKod;
    }

    get arbetsorderAnskaffningsform(): string {
        return this.model.arbetsorderAnskaffningsform;
    }

    get egenTransport(): boolean {
        return this.model.egenTransport;
    }

    get produktsatt(): boolean {
        return this.model.produktsatt;
    }

    get periodsattPeriod(): string {
        return this.model.periodsattPeriod;
    }
    get operationer(): IOperationBase[] {
        return this.model.operationer;
    }

    get viol3(): boolean {
        return this.model.viol3;
    }

    get koordinaterVerifierade(): boolean {
        return this.model.koordinaterVerifierade;
    }

    get isExternArbetsorder(): boolean {
        return this.model.isExternArbetsorder;
    }

    get isTerminalImport(): boolean {
        return this.model.isTerminalImport;
    }

    get anskaffningsform(): string {
        return this.model.anskaffningsform;
    }

    get atgarder(): IAtgard[] {
        return null;
    }

    get status(): string {
        return this.model.externArbetsorderStatus;
    }

    get felmeddelande(): string {
        let msg = this.model.externArbetsorderFelmeddelande;

        if (this.viol3Dirty) {
            msg = StringUtils.appendWithPunctuation(msg, "Behöver uppdateras mot Viol3.");
        }

        if (this.viol3Fel) {
            msg = StringUtils.appendWithPunctuation(msg, "Fel vid uppdatering till Viol3.");
        }

        return msg;
    }

    get isCFlis(): boolean {
        return this.model.isCFlis;
    }

    get viol3Dirty(): boolean {
        return this.model.viol3Dirty;
    }

    set viol3Dirty(value: boolean) {
        this.model.viol3Dirty = value;
    }

    get viol3Fel(): boolean {
        return this.model.viol3Fel;
    }

    set viol3Fel(value: boolean) {
        this.model.viol3Fel = value;
    }
}
